import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.scss";
import logo from "../../assets/images/logo.png";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    } else {
      navigate("/");
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: sectionId } });
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        const headerHeight = document.querySelector(".header").offsetHeight;
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const handleBuyNow = () => {
    navigate("/shop");
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <>
      <header className="header">
        <div className="header-left">
          <Link to="/" className="logo" onClick={handleLogoClick}>
            <img src={logo} alt="Logo" />
          </Link>
          <button className="mobile-menu-button" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? "✕" : "☰"}
          </button>
          <nav className="nav-menu">
            <a
              href="#who"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("who");
              }}
            >
              Who?
            </a>
            <a
              href="#news"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("news");
              }}
            >
              News
            </a>
            <a
              href="#problem"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("problem");
              }}
            >
              Problem
            </a>
            <a
              href="#solution"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("solution");
              }}
            >
              Solution
            </a>
            <a
              href="#nft-tiers"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("nft-tiers");
              }}
            >
              NFT Tiers
            </a>
            <a
              href="#revenue"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("revenue");
              }}
            >
              Revenue
            </a>
            <a
              href="#roadmap"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("roadmap");
              }}
            >
              Roadmap
            </a>
            <a
              href="#why"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("why");
              }}
            >
              Why?
            </a>
            <a
              href="#team"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection("team");
              }}
            >
              Team
            </a>
          </nav>
        </div>
        <div className="header-right">
          <Link to="/shop" className="shop-btn" onClick={handleBuyNow}>
            <span>Buy Now Presale</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.33331 8H12.6666" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M8 3.33337L12.6667 8.00004L8 12.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </div>
      </header>
      <nav className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
        <a
          href="#who"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("who");
          }}
        >
          Who?
        </a>
        <a
          href="#news"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("news");
          }}
        >
          News
        </a>
        <a
          href="#problem"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("problem");
          }}
        >
          Problem
        </a>
        <a
          href="#solution"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("solution");
          }}
        >
          Solution
        </a>
        <a
          href="#nft-tiers"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("nft-tiers");
          }}
        >
          NFT Tiers
        </a>
        <a
          href="#revenue"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("revenue");
          }}
        >
          Revenue
        </a>
        <a
          href="#roadmap"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("roadmap");
          }}
        >
          Roadmap
        </a>
        <a
          href="#why"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("why");
          }}
        >
          Why?
        </a>
        <a
          href="#team"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("team");
          }}
        >
          Team
        </a>
      </nav>
    </>
  );
};

export default Header;
